import React, { useEffect, useState } from "react";
import DashboardLayout from "../components/DashboardLayout";
import ClickOutsideWrapper from "../components/ClickOutSideWrapper";
import { useNavigate } from "react-router-dom";
import { auth, db, ref } from "../utilities/firebaseConfig";
import { get, onValue } from "firebase/database";
import timeicon from "../assets/ttime.svg";
import calendericon from "../assets/tcalendar.svg";
import TechnicianDashboardLayout from "../components/TechnicianDashboardLayout";

function TechnicianJobHistory() {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [btnactive, setBtnActive] = useState("All tasks");
  const [showorientation, setShowOrientation] = useState("list");
  const [sortam, setSortam] = useState("completed");
  const [activeJobs, setActiveJobs] = useState([]);
  useEffect(() => {
    const fetchActiveJobs = () => {
      const user = auth.currentUser;
      if (!user) {
        return;
      }

      const jobsRef = ref(db, "jobs");
      onValue(jobsRef, async (snapshot) => {
        if (snapshot.exists()) {
          const jobsData = Object.entries(snapshot.val()).map(([id, job]) => ({
            id,
            ...job,
          }));

          let filteredJobs = jobsData.filter(
            (job) => job.technicianId === user.uid
          );

          // Only include completed or cancelled jobs

          filteredJobs = filteredJobs.filter((job) => job.status === sortam);

          // For each filtered job, fetch the technician details (if technicianId exists).
          const jobsWithTechDetails = await Promise.all(
            filteredJobs.map(async (job) => {
              if (job.technicianId) {
                const techRef = ref(db, `technicians/${job.technicianId}`);
                const techSnapshot = await get(techRef);
                if (techSnapshot.exists()) {
                  return { ...job, technician: techSnapshot.val() };
                }
              }
              return job;
            })
          );

          setActiveJobs(jobsWithTechDetails);
        } else {
          setActiveJobs([]);
        }
      });
    };

    fetchActiveJobs();
  }, [sortam]); // 👈 now depends on selectedStatus

  const navlinkstas = [
    {
      id: 0,
      name: "All tasks",
    },
  ];

  const sortlist = [
    {
      id: 0,
      name: "completed",
    },
    {
      id: 1,
      name: "cancelled",
    },
  ];

  function formatDate(dateString) {
    const date = new Date(dateString);
    // Arrays for the short names of days and months.
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the components of the date.
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${dayName}, ${monthName} ${day}, ${year}`;
  }

  const formatWhatsAppTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();

    const diffInMs = now - date;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInWeeks = Math.floor(diffInDays / 7);
    const yearDiff = now.getFullYear() - date.getFullYear();
    const monthDiff = now.getMonth() - date.getMonth() + yearDiff * 12;

    const isToday = date.toDateString() === now.toDateString();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();

    if (diffInSeconds < 60) {
      return "Just now";
    } else if (isToday) {
      return "Today";
    } else if (isYesterday) {
      return "Yesterday";
    } else if (diffInDays < 7) {
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    } else if (diffInWeeks < 4) {
      return `${diffInWeeks} week${diffInWeeks > 1 ? "s" : ""} ago`;
    } else if (monthDiff >= 1) {
      return `${monthDiff} month${monthDiff > 1 ? "s" : ""} ago`;
    } else {
      return date.toLocaleDateString(undefined, {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    }
  };

  return (
    <>
      <TechnicianDashboardLayout>
        <div className='theclientdsh'>
          <div className='theclientdshtop'>
            <h1 className='theclidashbtntit'>Job History</h1>
          </div>
          <div className='thespac'></div>
          <div
            className='theclientdasnav'
            style={{ borderTop: "none", paddingBottom: "30px" }}
          >
            <div className='theclientdasleft'></div>
            <div className='theclientdashright'>
              <div className='thcdropsam'>
                <button className='thcdrop' onClick={() => setShowSort(true)}>
                  <label htmlFor=''>{sortam}</label>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 24 24'
                    width='36'
                    height='36'
                    fill='currentColor'
                  >
                    <path d='M12 14L8 10H16L12 14Z'></path>
                  </svg>
                </button>
                {showSort && (
                  <ClickOutsideWrapper
                    onClickOutside={() => setShowSort(false)}
                  >
                    <div className='sortfrcasn'>
                      {sortlist.map((sort, index) => (
                        <button
                          onClick={() => {
                            setSortam(sort.name);
                            setShowSort(false);
                          }}
                          id={sort.id}
                          className={`thesortshow ${
                            sortam === sort.name
                              ? "thesortshowactive"
                              : "thesortshownotactive"
                          }`}
                        >
                          {sort.name}
                        </button>
                      ))}
                    </div>
                  </ClickOutsideWrapper>
                )}
              </div>
            </div>
          </div>
          <div className='thespac'></div>
          {showorientation === "list" && (
            <div>
              {activeJobs.length > 0 ? (
                activeJobs.map((job) => (
                  <div
                    key={job.id}
                    className='thelasliksns'
                    onClick={() =>
                      navigate(`/technician/task_details/${job.id}`)
                    }
                  >
                    <h1 className='thelasjotit'>{job.jobtitle}</h1>
                    <p className='tehlasdes'>{job.jobdescription}</p>
                    <div className='teshimgname'>
                      <img
                        className='tablepix'
                        src={job.technician?.profileUrl}
                        alt=''
                      />
                      <span>
                        {job.userName} {job.userSurname}
                      </span>
                    </div>
                    <p className='tablesta'>{job.status}</p>
                    <p className='tabletimsa'>
                      {formatWhatsAppTimestamp(job.completedAt)}
                    </p>
                  </div>
                ))
              ) : (
                <p>You have no active jobs.</p>
              )}
            </div>
          )}
        </div>
      </TechnicianDashboardLayout>
    </>
  );
}

export default TechnicianJobHistory;
